import React from 'react'
// containers
import RiskEditContainer from 'containers/Risks/Risk/Edit'

const RiskEditPage: React.FC = () => <RiskEditContainer />

export default RiskEditPage
